/**
 * PATH: packages/pricelist/src/supplierFilter.ts
 * FILE_ID: PKG-PRICELIST-SUPPLIERFILTER-001
 * PURPOSE: Pure helpers for the toolbar "Supplier" filter — list the distinct
 *          suppliers present on a pricebook's sections, and narrow the visible
 *          section tabs to a chosen supplier.
 * WHY: Post-harvest each "Harvested — <Supplier>" section carries a real
 *      Supplier FK (surfaced as supplier_name). Operators asked to structure /
 *      filter the pricelist by supplier. Kept pure + exported so the logic is
 *      unit-tested independently of the React component.
 * RELATED: PricelistWorkbook.tsx (consumer), types.ts (PricelistSection)
 */
import type { PricelistSection } from './types'

/** Distinct, sorted supplier names across sections (empty/None dropped). */
export function distinctSuppliers(sections: PricelistSection[]): string[] {
  return Array.from(
    new Set(sections.map((s) => s.supplier_name).filter((n): n is string => !!n)),
  ).sort((a, b) => a.localeCompare(b))
}

/** Sections for the chosen supplier; empty filter ⇒ all sections unchanged. */
export function filterSectionsBySupplier(
  sections: PricelistSection[],
  supplierName: string,
): PricelistSection[] {
  if (!supplierName) return sections
  return sections.filter((s) => (s.supplier_name || '') === supplierName)
}
